import { render } from "./Background.vue?vue&type=template&id=41c354fa&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=41c354fa&lang=scss"
import "./Background.vue?vue&type=style&index=1&id=41c354fa&scoped=true&lang=css"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c354fa"]])

export default __exports__